import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { trackingEvents } from '../utils/trackingEvents'

type Props = {
  hasCoapplicant: boolean
  onSubmit: (event: { preventDefault: () => void }) => void
  cancelMyApp: (event: { preventDefault: () => void }) => void
  stepProgression: React.ReactElement
}

function FinalDecisionRefusedForm({ onSubmit, cancelMyApp, hasCoapplicant, stepProgression }: Props) {
  const { t } = useTranslation()
  const [isSubmitted, setSubmitted] = React.useState<boolean>(false)
  const creditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)

  React.useEffect(() => {
    if (creditApplication) {
      trackingEvents.qualifDeclined({
        credit_application_id: creditApplication.id,
        reference_number: creditApplication.referenceNumber,
        amount: creditApplication.finalDecision.maxAmountFinanced,
      })
    }
  }, [creditApplication])

  function innerSubmit(event: { preventDefault: () => void }) {
    setSubmitted(true)
    onSubmit(event)
  }
  return (
    <main className="form-section" style={{ textAlign: 'center' }}>
      {stepProgression}
      <form onSubmit={innerSubmit}>
        <h4 className="subtitle">{t<string>('common.financeApplication')}</h4>
        <h3>
          {t<string>(`finalDecision.refusedHasCoApplicant.${hasCoapplicant}`, {
            forStep: t<string>('common.qualified'),
          })}
        </h3>
        <div className="button-group-2">
          <div className="item">
            <button type="button" className="btn" onClick={cancelMyApp}>
              <span>{t<string>('common.cancelMyApp')}</span>
              <i className="fa-regular fa-ban" />
            </button>
          </div>
          {!hasCoapplicant && (
            <div className="item">
              <button type="submit" className="btn btn-blue" disabled={isSubmitted}>
                <span> {t('coapplicant.addCoapplicant')}</span>
                <i className="fa-regular fa-arrow-right" />
              </button>
            </div>
          )}
        </div>
      </form>
    </main>
  )
}

export default FinalDecisionRefusedForm
